export default __webpack_public_path__ + "static/0200-84312fdea1c2c826e2fb88ea0ed4da47.png";